import React, { useEffect, useRef, useState } from "react";
import "../styles/AboutSection.scss";
import img1 from "../assets/house_th.jpg";
import img2 from "../assets/tunelthing_ph.jpg";
import img3 from "../assets/panels_th.jpeg";
import img4 from "../assets/residence_th.jpg";
import img5 from "../assets/panels_2.jpeg";
import Logo from "../assets/logo.png";

const PROJECTS = [
  {
    title: "Aquecimento Solar Interno Completo",
    description:
      "Projeto completo com boiler para aquecimento de água interno.",
    img: img2,
  },
  {
    title: "Aquecimento Solar de Piscina",
    description: "Instalação de placas solares para água de piscina.",
    img: img1,
  },
  {
    title: "Aquecimento a Gás Residencial",
    description: "Instalação de unidade de aquecimento a gás para residência.",
    img: img4,
  },
  {
    title: "Projeto de Coletores Solares À Vácuo",
    description:
      "Utilização dos coletores em maior escala de distribuição interna.",
    img: img5,
  },
];

const AboutSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className={`about-section ${visible ? "visible" : ""}`} ref={ref}>
      <img src={Logo} height={50} alt="ThermalHydro" />
      <h2 className="title">Quem Somos?</h2>
      <p className="description">
        Nossa missão é levar ao cliente sistemas de aquecimento confiáveis,
        duradouros e adaptados às necessidades específicas de cada projeto, seja
        residencial, comercial ou industrial. Valorizamos a transparência, a
        qualidade dos materiais e o atendimento personalizado para construir
        parcerias duradouras.
      </p>
      <p className="description">
        A ThermalHydro nasceu do sonho de criar soluções de aquecimento que
        aliam tecnologia, eficiência e sustentabilidade. Fundada por
        especialistas do setor térmico, a empresa surgiu para atender a uma
        demanda crescente por sistemas modernos que oferecessem conforto e
        economia, sem abrir mão do cuidado com o meio ambiente, Desde o início,
        investimos em pesquisa e desenvolvimento, buscando as melhores
        tecnologias nacionais e internacionais para trazer ao mercado produtos
        inovadores e de alta performance.
      </p>
      <h3 className="subtitle">Alguns trabalhos realizados:</h3>
      <div className="gallery">
        {PROJECTS.map((item, i) => (
          <div className="gallery-item" key={i}>
            <img src={item.img} alt={`Projeto ${i}`} />
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutSection;
